/* PRICE LIST */
export const GET_PRICES_DATA = 'GET_PRICES_DATA';
export const GET_PRICES_DATA_SUCCESS = 'GET_PRICES_DATA_SUCCESS';
export const GET_PRICES_DATA_FAIL = 'GET_PRICES_DATA_FAIL';

export const ADD_PRICE_PRODUCT = 'ADD_PRICE_PRODUCT';
export const ADD_PRICE_PRODUCT_SUCCESS = 'ADD_PRICE_PRODUCT_SUCCESS';
export const ADD_PRICE_PRODUCT_FAIL = 'ADD_PRICE_PRODUCT_FAIL';

export const UPDATE_PRICE_PRODUCT = 'UPDATE_PRICE_PRODUCT';
export const UPDATE_PRICE_PRODUCT_SUCCESS = 'UPDATE_PRICE_PRODUCT_SUCCESS';
export const UPDATE_PRICE_PRODUCT_FAIL = 'UPDATE_PRICE_PRODUCT_FAIL';

export const DELETE_PRICE_PRODUCT = 'DELETE_PRICE_PRODUCT';
export const DELETE_PRICE_PRODUCT_SUCCESS = 'DELETE_PRICE_PRODUCT_SUCCESS';
export const DELETE_PRICE_PRODUCT_FAIL = 'DELETE_PRICE_PRODUCT_FAIL';

export const UPDATE_RESP_REGION = 'UPDATE_RESP_REGION';
export const UPDATE_RESP_REGION_SUCCESS = "UPDATE_RESP_REGION_SUCCESS";
export const UPDATE_RESP_REGION_FAIL = "UPDATE_RESP_REGION_FAIL";

export const CLEAR_FONT = 'CLEAR_FONT';
export const CLEAR_FONT_SUCCESS = 'CLEAR_FONT_SUCCESS';

export const GET_FONT = 'GET_FONT';
export const GET_FONT_SUCCESS = 'GET_FONT_SUCCESS';
export const GET_FONT_FAIL = 'GET_FONT_FAIL';

/* PRICE INFO */
export const GET_INFO_DATA = 'GET_INFO_DATA';
export const GET_INFO_DATA_SUCCESS = 'GET_INFO_DATA_SUCCESS';
export const GET_INFO_DATA_FAIL = 'GET_INFO_DATA_FAIL';

export const ADD_INFO_DATA = 'ADD_INFO_DATA';
export const ADD_INFO_DATA_SUCCESS = 'ADD_INFO_DATA_SUCCESS';
export const ADD_INFO_DATA_FAIL = 'ADD_INFO_DATA_FAIL';

export const UPDATE_INFO_DATA = 'UPDATE_INFO_DATA';
export const UPDATE_INFO_DATA_SUCCESS = 'UPDATE_INFO_DATA_SUCCESS';
export const UPDATE_INFO_DATA_FAIL = 'UPDATE_INFO_DATA_FAIL';

export const DELETE_INFO_DATA = 'DELETE_INFO_DATA';
export const DELETE_INFO_DATA_SUCCESS = 'DELETE_INFO_DATA_SUCCESS';
export const DELETE_INFO_DATA_FAIL = 'DELETE_INFO_DATA_FAIL';



// export const GET_CAT_PRODUCTS_DATA = 'GET_CAT_PRODUCTS_DATA';
// export const GET_CAT_PRODUCTS_DATA_SUCCESS = 'GET_CAT_PRODUCTS_DATA_SUCCESS';
// export const GET_CAT_PRODUCTS_DATA_FAIL = 'GET_CAT_PRODUCTS_DATA_FAIL';

// export const GET_ACCESS_DATA = 'GET_ACCESS_DATA';
// export const GET_ACCESS_DATA_SUCCESS = 'GET_ACCESS_DATA_SUCCESS';
// export const GET_ACCESS_DATA_FAIL = 'GET_ACCESS_DATA_FAIL';

// export const GET_PRODUCTS_DATA = 'GET_PRODUCTS_DATA';
// export const GET_PRODUCTS_DATA_SUCCESS = 'GET_PRODUCTS_DATA_SUCCESS';
// export const GET_PRODUCTS_DATA_FAIL = 'GET_PRODUCTS_DATA_FAIL';

// export const GET_REG_PRODUCTS_DATA = 'GET_REG_PRODUCTS_DATA';
// export const GET_REG_PRODUCTS_DATA_SUCCESS = 'GET_REG_PRODUCTS_DATA_SUCCESS';
// export const GET_REG_PRODUCTS_DATA_FAIL = 'GET_REG_PRODUCTS_DATA_FAIL';



// export const GET_REGION_INFO = 'GET_REGION_INFO';
// export const GET_REGION_INFO_SUCCESS = 'GET_REGION_INFO_SUCCESS';
// export const GET_REGION_INFO_FAIL = 'GET_REGION_INFO_FAIL';

// export const ADD_DATA_REGION = 'ADD_DATA_REGION';



export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
